import { Button } from "react-bootstrap";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { StyleSheet, css } from "aphrodite";


const styles = StyleSheet.create({
    linkButton: {
        padding: 0,
        marginTop: "2px",
        marginBottom: "10px",
    },
    linkButtonText: {
        margin: 0,
    },
})

const strings = {
    edit: "Edit",
    delete: "Delete",
};

export default class StoreExternalTender extends PureComponent {
    static propTypes = {
        tender: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            accounts: PropTypes.array.isRequired
        }).isRequired,
        index: PropTypes.number.isRequired,
        numTenders: PropTypes.number.isRequired,
        onEdit: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
        onReorder: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
    };

    _onEditClick = () => this.props.onEdit(this.props.tender);

    _onDeleteClick = () => this.props.onDelete(this.props.tender);

    _onReorderClick = (i) => this.props.onReorder(this.props.tender.id, i)

    render() {
        const { tender, index, numTenders } = this.props;
        return (
            <tr key={`${tender.id}`}>
                <td>{tender.name}</td>
                <td>
                    {tender.accounts.map((account) => account.name + " (" + account.percentage.toString() + "%)").join(', ')}
                </td>
                <td>
                    {
                        <div>
                            {index === 0 ? null : (
                                <Button
                                    onClick={() => this._onReorderClick(this.props.index - 1)}
                                    disabled={this.props.loading}
                                >
                                    &#9650;
                                </Button>
                            )}
                            {index ===
                            numTenders - 1 ? null : (
                                <Button
                                    onClick={() => this._onReorderClick(this.props.index + 1)}
                                    disabled={this.props.loading}

                                >
                                    &#9660;
                                </Button>
                            )}
                        </div>
                    }
                </td>
                <td>
                    <Button
                        className={css(styles.linkButton)}
                        bsStyle="link"
                        onClick={this._onEditClick}
                        disabled={this.props.loading}
                    >
                        <p className={css(styles.linkButtonText)}>{strings.edit}</p>
                    </Button>
                </td>
                <td>
                    <Button
                        className={css(styles.linkButton)}
                        bsStyle="link"
                        onClick={this._onDeleteClick}
                        disabled={this.props.loading}
                    >
                        <p className={css(styles.linkButtonText)}>{strings.delete}</p>
                    </Button>
                </td>
            </tr>
        );
    }
}
